module.exports = __webpack_public_path__ + "img/marker2.9b140792.png";